import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'gps.alerts.edit.fields.nameTitle' }),
    infoText: translate({ id: 'gps.alerts.edit.fields.nameDescription' }),
  }))

  return api
}
